import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * Handles the redirect back from Microsoft Entra ID (MSAL).
 * The actual token processing is performed in AuthContext's initialization
 * useEffect via msalInstance.handleRedirectPromise(). This component simply
 * waits until authentication is confirmed and then navigates to the home page.
 */
const MsalAuthCallback: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/', { replace: true });
        }
    }, [isAuthenticated, navigate]);

    return <div>Signing in with Microsoft...</div>;
};

export default MsalAuthCallback;
export { MsalAuthCallback };
